export default {
  backgroundColor: "#cee4e5",
};



// WEBPACK FOOTER //
// ./src/defaultMentionStyle.js